import { combineReducers } from 'redux';
import msiChangelogReducer from './MsiChangelog/MsiChangelog.reducers';
import { SET_FCF_MODE_SELECTION_ENABLED, SET_FCF_MODE_DATA } from './VenuePage.saga';

export const defaultState = {
  isFeatureFlagEnabled: false,
  canShowFcfSection: false,
  canBulkUpdate: false,
  eligibleManagedVenues: [],
};

const fcfModeSelectionReducer = (state = defaultState, { type, ...action }) => {
  switch (type) {
    case SET_FCF_MODE_SELECTION_ENABLED:
      return { ...state, isFeatureFlagEnabled: action.payload };
    case SET_FCF_MODE_DATA:
      return {
        ...state,
        canShowFcfSection: action.payload.canShowFcfSection,
        canBulkUpdate: action.payload.canBulkUpdate,
        currentVenueFcfMode: action.payload.currentVenue?.fcfMode,
        eligibleManagedVenues: action.payload.eligibleManagedVenues,
      };
    default:
      return state;
  }
};

export default combineReducers({
  msiChangelog: msiChangelogReducer,
  fcfModeSelection: fcfModeSelectionReducer,
});
